/* global RdcTracking */

const DEFAULT_VALUE = 'unknown';

export const trackSearch = function(searchBox, pageType) {
  const props = {
    linkName: `${pageType}:searchBox:${searchBox.name}-search`,
    searchType: searchBox.searchType,
    searchBox: getSearchBox(searchBox),
    searchQuery: searchBox.query,
    pageType: pageType,
    searchUserEnteredText: searchBox.userEnteredText,
    searchRank: getSearchRank(searchBox),
  };
  RdcTracking.trackEvent('search', props, null, true);
}

const getSearchBox = function(searchBox) {
  var searchFeature = searchBox.autoComplete || searchBox.feature;
  searchBox.name + ':' + searchFeature + ':' + searchBox.match;
}

const getSearchRank = function(searchBox={}) {
  const feature = searchBox.featureRank || DEFAULT_VALUE,
        overall = searchBox.overallRank || DEFAULT_VALUE;
  return `feature:${feature}|overall:${overall}`;
}



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/search.js